import { useCallback, useState } from 'react';
import * as yup from 'yup';

const schema = yup.object().shape({
  licensePlate: yup
    .string()
    .trim()
    .required('Placa é obrigatória')
    .min(8, 'Placa inválida'),
  brand: yup.object().nullable().required('Marca é obrigatória'),
  model: yup.object().nullable().required('Modelo é obrigatório'),
});

const defaultValues = {
  licensePlate: null,
  brand: null,
  model: null,
};

export const useNewVehicleForm = ({
  initialValues = defaultValues,
  validationSchema = schema,
}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const handleChange = useCallback((fieldName, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  }, []);

  const trigger = useCallback(
    async (fieldNames) => {
      const fieldsToValidate =
        fieldNames || Object.keys(validationSchema.fields);

      const partialSchema = yup.object(
        fieldsToValidate.reduce((acc, field) => {
          acc[field] = validationSchema.fields[field];
          return acc;
        }, {}),
      );

      try {
        await partialSchema.validate(values, { abortEarly: false });

        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          fieldsToValidate.forEach((field) => delete newErrors[field]);
          return newErrors;
        });

        return true;
      } catch (err) {
        if (err instanceof yup.ValidationError) {
          const newErrors = err.inner.reduce((acc, error) => {
            acc[error.path] = error.message;
            return acc;
          }, {});

          setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            fieldsToValidate.forEach((field) => delete updatedErrors[field]);
            return { ...updatedErrors, ...newErrors };
          });
        }
        return false;
      }
    },
    [validationSchema.fields, values],
  );

  return {
    values,
    errors,
    handleChange,
    trigger,
    setErrors,
  };
};
